import ClientDetailsModal from './ClientDetailsModal';
import MatchmakingStepperModal from './MatchmakingStepperModal';
import SupportRequestModal from './SupportRequestModal';
import MatchmakingHistoryDetailsModal from './MatchmakingHistoryDetailsModal';
import type { HistoryItem } from './MatchmakingHistoryPopover';
import type { StepperAnswers } from '../hooks/useMatchmakingStateManagement';

/**
 * Feature 060: Removed miles, setMiles, selectedServiceRanges, setSelectedServiceRanges props
 */
type ProDashboardMatchmakingModalsProps = {
  isClientModalOpen: boolean;
  setClientModalOpen: (open: boolean) => void;
  clientProfile: any;
  clientAvatar: string | undefined;
  ageDisplay: string;
  isLocationModalOpen: boolean;
  setIsLocationModalOpen: (open: boolean) => void;
  userClearedAddressRef: React.MutableRefObject<boolean>;
  onFindMatches: (answers: StepperAnswers) => void;
  selectedAddress: string;
  setSelectedAddress: (address: string) => void;
  onAddressSelectAndGeocode: (data: any) => void;
  addressResetTrigger: number;
  selectedState: string;
  selectedCounty: string;
  selectedZipCode: string;
  selectedLatitude: number | null;
  selectedLongitude: number | null;
  stepperAnswers: StepperAnswers;
  setStepperAnswers: (answers: StepperAnswers) => void;
  isSupportModalOpen: boolean;
  setIsSupportModalOpen: (open: boolean) => void;
  advisorEmail: string;
  advisorName: string;
  searchQuery: string;
  locationZipCode: string;
  locationState: string;
  locationCounty: string;
  locationAddress: string;
  isHistoryDetailsModalOpen: boolean;
  setIsHistoryDetailsModalOpen: (open: boolean) => void;
  historyItem: HistoryItem | null;
};

export const ProDashboardMatchmakingModals = ({
  isClientModalOpen,
  setClientModalOpen,
  clientProfile,
  clientAvatar,
  ageDisplay,
  isLocationModalOpen,
  setIsLocationModalOpen,
  userClearedAddressRef,
  onFindMatches,
  selectedAddress,
  setSelectedAddress,
  onAddressSelectAndGeocode,
  addressResetTrigger,
  selectedState,
  selectedCounty,
  selectedZipCode,
  selectedLatitude,
  selectedLongitude,
  stepperAnswers,
  setStepperAnswers,
  isSupportModalOpen,
  setIsSupportModalOpen,
  advisorEmail,
  advisorName,
  searchQuery,
  locationZipCode,
  locationState,
  locationCounty,
  locationAddress,
  isHistoryDetailsModalOpen,
  setIsHistoryDetailsModalOpen,
  historyItem,
}: ProDashboardMatchmakingModalsProps) => {
  return (
    <>
      <ClientDetailsModal
        isOpen={isClientModalOpen}
        onClose={() => setClientModalOpen(false)}
        clientProfile={clientProfile}
        clientAvatar={clientAvatar || ''}
        ageDisplay={ageDisplay}
      />

      <MatchmakingStepperModal
        isOpen={isLocationModalOpen}
        onClose={() => {
          setIsLocationModalOpen(false);
          userClearedAddressRef.current = false;
        }}
        onFindMatches={onFindMatches}
        selectedAddress={selectedAddress}
        setSelectedAddress={(address) => {
          setSelectedAddress(address);
          if (!address || address.trim() === '') {
            userClearedAddressRef.current = true;
          }
        }}
        onAddressSelectAndGeocode={onAddressSelectAndGeocode}
        addressResetTrigger={addressResetTrigger}
        selectedState={selectedState}
        selectedCounty={selectedCounty}
        selectedZipCode={selectedZipCode}
        selectedLatitude={selectedLatitude}
        selectedLongitude={selectedLongitude}
        persistedAnswers={stepperAnswers}
        setPersistedAnswers={setStepperAnswers}
      />

      <SupportRequestModal
        isOpen={isSupportModalOpen}
        onClose={() => setIsSupportModalOpen(false)}
        advisorEmail={advisorEmail}
        advisorName={advisorName}
        searchQuery={searchQuery}
        locationZipCode={locationZipCode}
        locationState={locationState}
        locationCounty={locationCounty}
        locationAddress={locationAddress}
      />

      <MatchmakingHistoryDetailsModal
        isOpen={isHistoryDetailsModalOpen}
        onClose={() => setIsHistoryDetailsModalOpen(false)}
        historyItem={historyItem}
      />
    </>
  );
};

